import {StyleSheet} from "aphrodite/no-important"

export const styles = StyleSheet.create({
    page: {
        minHeight: "100%",
        maxHeight: "100%",
    },
    content: {
        display: "grid",
        minHeight: "100%",
        gridTemplateColumns: "min-content auto min-content",
        gridColumnGap: "20px"
    },
    filterList: {
        height: "calc(100vh - 200px - 163px - 35px)",
        maxHeight: "calc(100vh - 200px - 163px - 35px)",
        display: "inline-block",
        width: "300px",
        overflowY: "hidden",
        overFlowX: "hidden",
        marginTop: "10px",
        marginLeft: "10px",
        ":hover": {
            overflowY: "auto"
        }
    },
    parentEntity: {
        display: "grid",
        gridTemplateColumns: "20px auto 20px",
        boxSizing: "border-box",
        width: "260px",
        alignItems: "center",
        fontSize: "14px", 
        fontWeight: "bold",
        margin: "5px 0px 5px 5px",
        padding: "5px 5px 5px 10px",
        borderRadius: "20px",
        backgroundColor: "#efefef",
        "user-select": "none",
        ":hover": {
            cursor: "pointer",
            backgroundColor: "#e2e2e2",
        }
    },
    childEntity: {
        display: "grid",
        gridTemplateColumns: "20px auto 20px",
        width: "230px",
        fontSize: "12px",
        fontWeight: "normal",
        alignItems: "center",
        margin: "5px 0px 5px 30px",
        "user-select": "none"
    },
    leafChildEntity: {
        display: "grid",
        gridTemplateColumns: "20px 150px",
        fontSize: "10px",
        fontWeight: "normal",
        alignItems: "center",
        margin: "5px 0px 5px 60px",
        "user-select": "none"
    },
    expandIcon: {
        marginLeft: "auto",
        marginRight: "10px"
    },
    expandIconChild: {
        marginLeft: "auto",
        marginRight: "10px",
        fontSize: "10px",
        ":hover": {
            color: "rgb(0, 83, 159)",
            cursor: "pointer"
        }
    },
    checkBoxIcon: {
        marginLeft: "auto",
        marginRight: "10px",
        fontSize: "14px",
        ":hover": {
            color: "rgb(0, 83, 159)",
            cursor: "pointer"
        }
    },
    title: {
        marginLeft: "10px"
    },
    clear: {
        fontSize: "12px",
        color: "rgb(0, 83, 159)",
        ":hover": {
            cursor: "pointer"
        },
        marginLeft: "auto",
        marginRight: "5px"
    },
    searchBox: {
        width: "90%",
        margin: "10px 10px 5px 10px",
        padding: "5px 10px 5px 10px"
    },
    hover: {
        ":hover": {
            cursor: "pointer",
        }
    },
    centerHorizontal: {
        position: "absolute",
        left: "50%",
        transform: "translate(-50%)"
    },
    
    pieChart: {
        position: "absolute",
        left: "50%",
        top: "40%",
        transform: "translate(-50%, -50%)"
    },

    barChartContainer: {
        position: "absolute",
        left: "52%",
        top: "50%",
        transform: "translate(-50%, -55%)",
        alignSelf: "center",
        maxWidth: "calc(100vw - (260px + 310px))",
        overflowX: "hidden",
        ":hover": {
            overflowX: "auto"
        }
    },

    header: {
        display: "flex",
        flexDirection: "row",
        width: "min-content",
        marginTop: "15px",
        marginBottom: "20px",
        marginLeft: "20px",
        backgroundColor: "#efefef",
        padding: "5px 20px 5px 20px",
        borderRadius: "20px",
        letterSpacing: "1px",
        "-webkit-font-smoothing": "auto",
        "-moz-osx-font-smoothing": "auto",
        fontFamily: "greycliff-bold",
        textTransform: "uppercase",
    },

    headerItem: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginRight: "10px",
    },
    headerItemLast: {
        marginRight: "10px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        ":hover": {
            cursor: "pointer",
            textDecoration: "underline"
        }
    },
    
    views: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#e2e2e2",
        width: "min-content",
        height: "min-content",
        marginTop: "20px",
        marginRight: "20px",
        borderRadius: "5px",
        padding: "10px 40px 10px 20px",
        whiteSpace: "nowrap"
    },

    viewTitle: {
        fontSize: '16px',
        fontWeight: "bold",
        margin: "5px 0px 10px 0px"
    },

    viewOption: {
        marginLeft: '10px'
    },

    radioButton: {
        marginRight: "5px"
    },

    legend : {
        display:  "inline",
        marginLeft: "auto",
        marginRight: "auto"
    },

    legendItem: {
        display: "inline",  
    },

    aggregate: {
        display: "flex",
        flexDirection: "column",
        marginLeft: "20px"
    }
    
});


// WEBPACK FOOTER //
// ./src/pages/AggregateCollegeStyle.ts